import styled from 'styled-components';

export const GridContainer = styled.div`
  width: 100%;
  height: calc(100% - 60px);
`;
